<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>График работы</T>
    </Teleport>
    
    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-277"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>

    <Schedule :loading="loading" :config="$store.getters.local_refs" ref="form" />
  </div>
</template>

<script>
import Schedule from '../../components/settings/schedule'
import Teleport from 'vue2-teleport'

export default {
  components:{
    Teleport,
    Schedule
  },
   data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {schedule: this.$refs.form.submit()}

        await this.$store.dispatch('updateLocalRefs', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>